import { render, staticRenderFns } from "./ScSaleRanking.vue?vue&type=template&id=035bec96&"
import script from "./ScSaleRanking.vue?vue&type=script&lang=js&"
export * from "./ScSaleRanking.vue?vue&type=script&lang=js&"
import style0 from "./ScSaleRanking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports